// Electric Conductance units with conversion factors to siemens (S)
export const electricConductanceUnits = [
  { id: 'siemens', name: 'Siemens', symbol: 'S', plural: 'Siemens', factor: 1 },
  { id: 'megasiemens', name: 'Megasiemens', symbol: 'MS', plural: 'Megasiemens', factor: 1e6 },
  { id: 'kilosiemens', name: 'Kilosiemens', symbol: 'kS', plural: 'Kilosiemens', factor: 1e3 },
  { id: 'millisiemens', name: 'Millisiemens', symbol: 'mS', plural: 'Millisiemens', factor: 1e-3 },
  { id: 'microsiemens', name: 'Microsiemens', symbol: 'µS', plural: 'Microsiemens', factor: 1e-6 },
  { id: 'mho', name: 'Mho', symbol: '℧', plural: 'Mhos', factor: 1 },
  { id: 'gemmho', name: 'Gemmho', symbol: 'gemmho', plural: 'Gemmhos', factor: 1e-6 },
  { id: 'micromho', name: 'Micromho', symbol: 'µ℧', plural: 'Micromhos', factor: 1e-6 },
  { id: 'abmho', name: 'Abmho', symbol: 'abmho', plural: 'Abmhos', factor: 1e9 },
  { id: 'statmho', name: 'Statmho', symbol: 'statmho', plural: 'Statmhos', factor: 1.112650e-12 },
  { id: 'ampere-per-volt', name: 'Ampere/Volt', symbol: 'A/V', plural: 'Amperes/Volt', factor: 1 },
];

export const popularElectricConductanceConversions = [
  { from: 'siemens', to: 'millisiemens' },
  { from: 'millisiemens', to: 'siemens' },
  { from: 'siemens', to: 'microsiemens' },
  { from: 'siemens', to: 'mho' },
  { from: 'mho', to: 'siemens' },
  { from: 'millisiemens', to: 'microsiemens' },
];

export const getUnitById = (id) => electricConductanceUnits.find(unit => unit.id === id);

export const convertElectricConductance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric conductance units and learn the conversion formula.`;
};
